import { render, staticRenderFns } from "./ResearchOverviewPage.vue?vue&type=template&id=0941f488"
import script from "./ResearchOverviewPage.vue?vue&type=script&lang=js"
export * from "./ResearchOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./ResearchOverviewPage.vue?vue&type=style&index=0&id=0941f488&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports